import { generateStripeState } from '../helper'

const options = {
  api: '/api/stripe/balance/transactions',
  state: {
    collectionName: 'balanceTransactions'
  },
  getters: {
    getPagination: 'getBalanceTransactionPagination',
    getCollection: 'getBalanceTransactions'
  },
  actions: {
    fetch: 'fetchBalanceTransactions'
  },
  mutationKey: 'BALANCE_TRANSACTIONS'
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions
  },
  mutations:{
    ...stripeMutations
  }
}
